module.exports = __webpack_public_path__ + "img/no-car-image - Copy.d12febc7.png";